import capitalDeposit from './capitalDeposit';
import afterCapitalDeposit from './afterCapitalDeposit';
import companyInfo from './companyInfo';

export default {
  ...capitalDeposit,
  ...afterCapitalDeposit,
  ...companyInfo,
};
